var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ConsoleAdapter_config;
const MESSAGES = {
    initialized: '[Analytics:Console] Adapter initialized',
    event_sent: '[Analytics:Console] Event:',
    global_props_added: '[Analytics:Console] Global properties added:',
    destroyed: '[Analytics:Console] Adapter destroyed',
};
export class ConsoleAdapter {
    constructor(config = {}) {
        this.name = 'Console';
        _ConsoleAdapter_config.set(this, void 0);
        __classPrivateFieldSet(this, _ConsoleAdapter_config, config, "f");
    }
    async init() {
        console.log(MESSAGES.initialized, __classPrivateFieldGet(this, _ConsoleAdapter_config, "f"));
        return true;
    }
    sendEvent(action, data) {
        console.log(MESSAGES.event_sent, action, data);
        return true;
    }
    addGlobalProperties(properties) {
        console.log(MESSAGES.global_props_added, properties);
        return true;
    }
    checkUserChanged() {
        return false;
    }
    destroy() {
        console.log(MESSAGES.destroyed);
    }
}
_ConsoleAdapter_config = new WeakMap();
